import { apiClient } from "./client";
import {
  ChatGroup,
  QuickReply,
  QuickReplyDirection,
  QuickReplyTopic,
} from "../types";

export const organizerService = {
  groups: async (): Promise<ChatGroup[]> =>
    (await apiClient.get("/chat-groups")).data,
  createGroup: async (name: string, color: string): Promise<ChatGroup> =>
    (await apiClient.post("/chat-groups", { name, color })).data,
  updateGroup: async (
    id: string,
    payload: Partial<Pick<ChatGroup, "name" | "color">>,
  ): Promise<ChatGroup> =>
    (await apiClient.patch(`/chat-groups/${id}`, payload)).data,
  deleteGroup: async (id: string): Promise<void> => {
    await apiClient.delete(`/chat-groups/${id}`);
  },
  assignGroups: async (chatId: string, groupIds: string[]): Promise<void> => {
    await apiClient.put(`/chats/${encodeURIComponent(chatId)}/groups`, {
      group_ids: groupIds,
    });
  },
  replies: async (): Promise<QuickReply[]> =>
    (await apiClient.get("/quick-replies")).data,
  replyDirections: async (): Promise<QuickReplyDirection[]> =>
    (await apiClient.get("/quick-reply-directions")).data,
  createTopic: async (
    directionId: string,
    name: string,
  ): Promise<QuickReplyTopic> =>
    (
      await apiClient.post("/quick-reply-topics", {
        direction_id: directionId,
        name,
      })
    ).data,
  updateTopic: async (id: string, name: string): Promise<QuickReplyTopic> =>
    (await apiClient.patch(`/quick-reply-topics/${id}`, { name })).data,
  deleteTopic: async (id: string): Promise<void> => {
    await apiClient.delete(`/quick-reply-topics/${id}`);
  },
  createReply: async (topicId: string, text: string): Promise<QuickReply> =>
    (await apiClient.post("/quick-replies", { topic_id: topicId, text })).data,
  updateReply: async (id: string, text: string): Promise<QuickReply> =>
    (await apiClient.patch(`/quick-replies/${id}`, { text })).data,
  deleteReply: async (id: string): Promise<void> => {
    await apiClient.delete(`/quick-replies/${id}`);
  },
  reorderReplies: async (ids: string[]): Promise<void> => {
    await apiClient.put("/quick-replies/order", { ids });
  },
};
